export default "<uib-accordion close-others=\"true\">\n  <ng-transclude></ng-transclude>\n</uib-accordion>\n";